import React, { FC } from 'react';
import { typeHelpers } from '@polymathnetwork/new-shared';
import { Modal } from '~/components/Modal';
import { Button } from '~/components/Button';
import { ButtonLarge } from '~/components/ButtonLarge';

type ModalProps = typeHelpers.GetProps<typeof Modal>;

export interface Props extends ModalProps {
  isActionDisabled?: boolean;
  actionButtonText?: string;
  cancelButtonText?: string;
  onSubmit: () => void;
  onClose: () => void;
}

const ModalConfirmBase: FC<Props> = props => {
  const {
    isOpen,
    onClose,
    onSubmit,
    isActionDisabled,
    actionButtonText,
    cancelButtonText,
    children,
    ...otherProps
  } = props;
  return (
    <Modal isOpen={isOpen} onClose={onClose} {...otherProps}>
      {children}
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {cancelButtonText}
        </Button>
        <ButtonLarge
          variant="primary"
          onClick={onSubmit}
          disabled={isActionDisabled}
        >
          {actionButtonText}
        </ButtonLarge>
      </Modal.Footer>
    </Modal>
  );
};

export const ModalConfirm = Object.assign(ModalConfirmBase, {
  Header: Modal.Header,
  Body: Modal.Body,
  defaultProps: {
    isActionDisabled: false,
    actionButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
  },
});
try {
    // @ts-ignore
    ModalConfirm.displayName = "ModalConfirm";
    // @ts-ignore
    ModalConfirm.__docgenInfo = { "description": "", "displayName": "ModalConfirm", "props": { "isActionDisabled": { "defaultValue": null, "description": "", "name": "isActionDisabled", "required": false, "type": { "name": "boolean" } }, "actionButtonText": { "defaultValue": null, "description": "", "name": "actionButtonText", "required": false, "type": { "name": "string" } }, "cancelButtonText": { "defaultValue": null, "description": "", "name": "cancelButtonText", "required": false, "type": { "name": "string" } }, "onSubmit": { "defaultValue": null, "description": "", "name": "onSubmit", "required": true, "type": { "name": "() => void" } }, "onClose": { "defaultValue": null, "description": "", "name": "onClose", "required": true, "type": { "name": "() => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ModalConfirm/ModalConfirm.tsx#ModalConfirm"] = { docgenInfo: ModalConfirm.__docgenInfo, name: "ModalConfirm", path: "src/components/ModalConfirm/ModalConfirm.tsx#ModalConfirm" };
}
catch (__react_docgen_typescript_loader_error) { }